/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Other_L10nInputs */

const en_footer_other_l10n = /** @type {(inputs: Footer_Other_L10nInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggest translation improvement`)
};

/**
* | output |
* | --- |
* | "Suggest translation improvement" |
*
* @param {Footer_Other_L10nInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_other_l10n = /** @type {((inputs?: Footer_Other_L10nInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Other_L10nInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_other_l10n(inputs)
});